import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';
import axios from 'axios';
import ProductCard from '@/components/ProductCard';
import { useWishlist } from '@/hooks/useWishlist';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WishlistPage() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchAll = async () => {
      setLoading(true);
      try {
        if (ids.length === 0) {
          setProducts([]);
        } else {
          const results = await Promise.all(
            ids.map((id) =>
              axios.get(`${API}/products/${id}`).then((r) => r.data).catch(() => null)
            )
          );
          if (!cancelled) setProducts(results.filter(Boolean));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchAll();
    return () => {
      cancelled = true;
    };
  }, [ids]);

  return (
    <div className="pt-28 pb-16 min-h-screen" data-testid="wishlist-page">
      <div className="container-custom px-6 md:px-12 lg:px-24">
        <div className="text-center mb-12">
          <p className="text-caption text-[#84A98C] mb-4">Saved for Later</p>
          <h1 className="heading-display text-4xl md:text-5xl text-[#354F52] mb-4">
            Your Wishlist
          </h1>
          {ids.length > 0 && (
            <p className="text-[#52796F]">
              {ids.length} bracelet{ids.length === 1 ? '' : 's'} you're considering
            </p>
          )}
        </div>

        {loading ? (
          <div className="text-center text-[#84A98C] py-12">Loading...</div>
        ) : products.length === 0 ? (
          <div className="text-center py-16 max-w-md mx-auto">
            <div className="w-20 h-20 bg-[#F5F5F0] rounded-full flex items-center justify-center mx-auto mb-6">
              <Heart className="w-10 h-10 text-[#84A98C]" strokeWidth={1.5} />
            </div>
            <p className="text-[#52796F] mb-6">
              Your wishlist is empty. Tap the heart on any bracelet to save it for later.
            </p>
            <Link to="/products" className="btn-primary inline-flex items-center gap-2" data-testid="wishlist-shop-btn">
              Browse Bracelets
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
